import { Fragment } from 'react';
import * as s from './KbdHint.css';

export type KbdSize = 'sm' | 'md';

export interface KbdHintProps {
  /** 키 표시 — 단일 ('⏎', 'N', 'Esc') 또는 다중 ('⌘+K'). 빈 문자열 이면 렌더 안 함. */
  k: string;
  size?: KbdSize;
  ariaLabel?: string;
  className?: string;
}

/**
 * 키보드 단축키 힌트 표기. 다중 키는 '+' 로 구분, '+' 자체는 dim 처리되어
 * 보조 글리프로 표현. caller 가 ariaLabel 미지정 시 k 가 그대로 읽힘.
 */
export function KbdHint({ k, size = 'sm', ariaLabel, className }: KbdHintProps) {
  if (k === '') return null;

  const parts = k.split('+').map((p) => p.trim());
  const cls = `${s.kbd({ size })}${className ? ` ${className}` : ''}`;

  // 단일 키
  if (parts.length === 1) {
    return (
      <kbd className={cls} aria-label={ariaLabel}>
        {k}
      </kbd>
    );
  }

  // 다중 키 — '+' 별로 kbd, 사이에 dim 처리된 separator
  return (
    <span aria-label={ariaLabel ?? k} role={ariaLabel ? undefined : 'group'}>
      {parts.map((p, i) => (
        <Fragment key={`${p}-${i}`}>
          {i > 0 && <span style={{ opacity: 0.5, margin: '0 2px' }}>+</span>}
          <kbd className={cls}>{p}</kbd>
        </Fragment>
      ))}
    </span>
  );
}
